// Constant values
const LOCAL_STORAGE_RELATED_PRODUCTS_KEY = "related-products";
const RECENT_PRODUCTS_GRID_LOADED_CLASS = "loaded";
const RELATED_PRODUCTS_MAX_COUNT = 15;
const RELATED_PRODUCT_HANDLE = Shopify.Products.productHandle || false;

// Selectors for DOM elements
const relatedproductsSelectors = {
  button: "[related-products-wrapper]",
  grid: "[grid-related-products]",
  productCard: ".wishlist-card .product-card",
};

// Event listener when the DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  initRelatedGrid();
});

// Event listener for when the product grid is initialized
document.addEventListener(
  "shopify-related-products:init-product-grid",
  (event) => {
    relatedProductsSlider();
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  }
);

// // Fetches the HTML content for a product card using its handle
const fetchRelatedProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=product-card`;
  return fetch(productTileTemplateUrl)
    .then((res) => res.text())
    .then((res) => {
      const text = res;
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, "text/html");
      const productCard = htmlDocument.documentElement.querySelector(
        relatedproductsSelectors.productCard
      );
      return productCard.outerHTML;
    })
    .catch((err) =>
      console.log(
        `[Shopify Related Products] Failed to load content for handle: ${handle}`
      )
    );
};

// Sets up the product grid with the recent products
const setupRelatedGrid = async (grid) => {
  const recentProducts = getRelatedList();
  const requests = recentProducts.map(fetchRelatedProductCardHTML);
  const responses = await Promise.all(requests);
  const recentProductCards = responses.join("");
  grid.innerHTML = recentProductCards;
  grid.classList.add(RECENT_PRODUCTS_GRID_LOADED_CLASS);

  const event = new CustomEvent("shopify-related-products:init-product-grid", {
    detail: { recentProducts: recentProducts },
  });
  document.dispatchEvent(event);
};

// Initializes the product grid
const initRelatedGrid = () => {
  const grid = document.querySelector(relatedproductsSelectors.grid) || false;
  if (grid) {
    setupRelatedGrid(grid);
  }
};

// Retrieves the recentProducts from local storage
const getRelatedList = () => {
  const relatedProductsJSON =
  Shopify.Products.relatedProductsHandle || [];
  return relatedProductsJSON;
};


